import Model from "./Model";

export default class MediumCoverage extends Model {
  static type = "MediumCoverage";
  mediumTypeId!: string;
  typology!: string;
  reach!: string;
  budget!: string;
  budgetDescription!: string;
  exportGranularity!: string;
  audience!: number;
  dispersion!: number;
  coverage?: number;
  quantity?: number;
  tooltip?: string;
}
